/**
 * Selector de plantillas del editor (PDP).
 *
 * Lee el catálogo público del editor y deja elegir plantilla antes de entrar.
 * La plantilla ya NO depende de la variante: el metacampo de variante solo
 * enlaza las dos cosas.
 *
 * Sincroniza en ambos sentidos con el selector de variante de Dawn:
 *   plantilla elegida → variante (fotos y precio se actualizan solos)
 *   variante elegida  → plantilla marcada
 */
(function () {
  var BADGES = {
    NUEVO: 'Nuevo',
    POPULAR: 'Popular',
    TENDENCIA: 'Tendencia',
  };

  // Una sola petición aunque haya varios CTA en la misma página.
  var catalogPromise = null;

  function fetchCatalog(rawApiBase) {
    if (!catalogPromise) {
      // El metacampo de tienda puede venir con o sin barra final.
      var apiBase = (rawApiBase || '').replace(/\/+$/, '');
      catalogPromise = fetch(apiBase + '/api/storefront/templates', { credentials: 'omit' })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function (data) {
          return Array.isArray(data.templates) ? data.templates : [];
        });
    }
    return catalogPromise;
  }

  function normalize(text) {
    return (text || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function parseJSON(el, fallback) {
    if (!el) return fallback;
    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      console.warn('[editor-template-picker] JSON inválido', error);
      return fallback;
    }
  }

  function init(root) {
    var link = root.querySelector('[data-editor-cta]');
    var picker = root.querySelector('[data-etp]');
    if (!link) return;

    var variants = parseJSON(root.querySelector('[data-etp-variants]'), []);
    var selectedId = root.getAttribute('data-preselected-template-id') || null;
    // Evita el bucle plantilla → variante → plantilla.
    var syncing = false;

    function refreshHref() {
      var baseUrl = root.getAttribute('data-editor-base-url');
      var productId = root.getAttribute('data-editor-product-id');
      if (!baseUrl || !productId) return;

      var sep = baseUrl.indexOf('?') === -1 ? '?' : '&';
      var url =
        baseUrl +
        sep +
        'productId=' +
        encodeURIComponent(productId) +
        '&editorType=advanced&shopifyVariantId=' +
        encodeURIComponent(root.getAttribute('data-shopify-variant-id') || '');
      // Sin plantilla el editor abre su propia galería, así que el CTA sigue
      // siendo válido: nunca lo ocultamos.
      if (selectedId) url += '&templateId=' + encodeURIComponent(selectedId);
      link.setAttribute('href', url);
    }

    /**
     * Marca en el selector de variante de Dawn la variante que corresponde a la
     * plantilla elegida. Dawn escucha el `change` de cada input, así que
     * disparándolo se encarga él de refrescar fotos, precio y el input oculto.
     */
    function applyVariantFor(templateId) {
      var selects = document.querySelector('variant-selects');
      if (!selects) return;

      var variant = variants.filter(function (v) {
        return v.templateId === templateId;
      })[0];
      if (!variant || String(variant.id) === String(root.getAttribute('data-shopify-variant-id'))) {
        return;
      }

      var groups = selects.querySelectorAll('.product-form__input');
      var changed = [];

      (variant.options || []).forEach(function (value, index) {
        var group = groups[index];
        if (!group) return;

        var radios = group.querySelectorAll('input[type="radio"]');
        for (var i = 0; i < radios.length; i++) {
          if (radios[i].value === value) {
            if (!radios[i].checked) {
              radios[i].checked = true;
              changed.push(radios[i]);
            }
            return;
          }
        }

        var select = group.querySelector('select');
        if (select && select.value !== value) {
          select.value = value;
          changed.push(select);
        }
      });

      syncing = true;
      changed.forEach(function (input) {
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      syncing = false;
    }

    if (!picker) {
      refreshHref();
      return;
    }

    var list = picker.querySelector('[data-etp-list]');
    var search = picker.querySelector('[data-etp-search]');
    var empty = picker.querySelector('[data-etp-empty]');
    var templates = [];

    function markSelection() {
      var options = list.querySelectorAll('[data-etp-option]');
      for (var i = 0; i < options.length; i++) {
        var isSelected = options[i].getAttribute('data-id') === selectedId;
        options[i].classList.toggle('is-selected', isSelected);
        options[i].setAttribute('aria-selected', isSelected ? 'true' : 'false');
      }
      refreshHref();
    }

    /**
     * Centra la plantilla marcada dentro de la lista. Se mueve `scrollTop` a
     * mano en vez de usar scrollIntoView(), que además arrastraría la página.
     *
     * Con rectángulos y no con offsetTop: la lista no crea contexto de
     * posicionamiento, así que offsetTop se mide desde un ancestro cualquiera.
     */
    function scrollToSelection() {
      requestAnimationFrame(function () {
        var option = list.querySelector('[data-etp-option].is-selected');
        if (!option) return;
        var listRect = list.getBoundingClientRect();
        var optionRect = option.getBoundingClientRect();
        var delta = optionRect.top - listRect.top - (list.clientHeight - optionRect.height) / 2;
        list.scrollTop = Math.max(0, list.scrollTop + delta);
      });
    }

    function select(id, fromVariant) {
      selectedId = id;
      markSelection();
      // Al elegir a mano la fila ya está a la vista; moverla sería molesto.
      if (fromVariant) scrollToSelection();
      else applyVariantFor(id);
    }

    function render(visible) {
      list.textContent = '';
      visible.forEach(function (template) {
        var item = document.createElement('li');
        item.className = 'etp__option';
        item.setAttribute('data-etp-option', '');
        item.setAttribute('data-id', template.id);
        item.setAttribute('role', 'option');
        item.setAttribute('tabindex', '0');

        var thumb = document.createElement('span');
        thumb.className = 'etp__thumb';
        if (template.previewUrl) {
          var img = document.createElement('img');
          img.src = template.previewUrl;
          img.alt = '';
          img.loading = 'lazy';
          thumb.appendChild(img);
        }

        var name = document.createElement('span');
        name.className = 'etp__name';
        name.textContent = template.nombre;

        item.appendChild(thumb);
        item.appendChild(name);

        if (template.badge && BADGES[template.badge]) {
          var badge = document.createElement('span');
          badge.className = 'etp__badge etp__badge--' + template.badge.toLowerCase();
          badge.textContent = BADGES[template.badge];
          item.appendChild(badge);
        }

        var check = document.createElement('span');
        check.className = 'etp__check';
        check.setAttribute('aria-hidden', 'true');
        check.innerHTML =
          '<svg viewBox="0 0 20 20" focusable="false"><path d="M5.5 10.5l3 3 6-6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        item.appendChild(check);

        list.appendChild(item);
      });

      empty.hidden = visible.length > 0;
      markSelection();
      scrollToSelection();
    }

    list.addEventListener('click', function (event) {
      var option = event.target.closest('[data-etp-option]');
      if (option) select(option.getAttribute('data-id'));
    });

    list.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var option = event.target.closest('[data-etp-option]');
      if (!option) return;
      event.preventDefault();
      select(option.getAttribute('data-id'));
    });

    search.addEventListener('input', function () {
      var term = normalize(search.value).trim();
      render(
        term
          ? templates.filter(function (t) {
              return normalize(t.nombre).indexOf(term) !== -1;
            })
          : templates
      );
    });

    // Variante cambiada desde el selector nativo → marcamos su plantilla.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        if (!variant) return;
        root.setAttribute('data-shopify-variant-id', variant.id);

        var entry = variants.filter(function (v) {
          return String(v.id) === String(variant.id);
        })[0];
        var exists =
          entry &&
          entry.templateId &&
          templates.some(function (t) {
            return t.id === entry.templateId;
          });

        // Si la variante no tiene plantilla publicada, se respeta la elegida.
        if (!syncing && exists) select(entry.templateId, true);
        else refreshHref();
      });
    }

    fetchCatalog(root.getAttribute('data-editor-api-base'))
      .then(function (fetched) {
        if (!fetched.length) return; // sin catálogo, el CTA se queda tal cual
        templates = fetched;

        // La plantilla de la variante solo manda si sigue publicada; si no,
        // caemos en la primera del orden definido en el backoffice.
        var stillExists = templates.some(function (t) {
          return t.id === selectedId;
        });
        if (!stillExists) selectedId = templates[0].id;

        picker.hidden = false;
        render(templates);
      })
      .catch(function (error) {
        // El selector no aparece, pero el enlace de respaldo sigue funcionando.
        console.warn('[editor-template-picker] catálogo no disponible', error);
        refreshHref();
      });
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-editor-cta-root]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
